'use strict';

import { BaseController } from '../../../../base/controller';
import SepaCountries from '../../../../data/source/sepaCountries.factory';
import _ from 'lodash';

export class PaymentPartnerEditingController extends BaseController {
  constructor(
    $rootScope,
    $scope,
    controllerService,
    cardService,
    uiModalDeclarationService,
    creditorsService,
    ticketService,
  ) {
    'ngInject';
    super({
      $rootScope,
      $scope,
      controllerService,
      cardService,
      uiModalDeclarationService,
      creditorsService,
      ticketService,
    });
  }

  $onInit() {
    this.card = this.resolve.card;
    this.countryOptions = SepaCountries().selectables;
    this.isAddressOpen = true;
    this.searchDebounced = _.debounce(
      this.cardService.findCreditorsSearch.bind(this),
      200,
    );
    this.options = {
      searchText: '',
    };

    this.model = angular.copy(this.card.partner);
    this.model.mref = this.card.mref;
    this.model.contracts = angular.copy(this.card.contracts);
    this.model.purpose = this.card.purpose;
    this.model.comment = this.card.comment;
    this.model.country =
      this.card.partner.country || this.envService.countryCode || 'DE';
  }

  $postLink() {
    this.form.$setSubmitted();
  }

  cancel() {
    this.dismiss({ $value: this.card });
  }

  setCreditor(creditor) {
    this.card.searchResults = [];
    this.options.searchText = '';
    this.model = _.assign(this.model, creditor);
  }

  search() {
    return this.searchDebounced(this);
  }

  assignModelToCard() {
    const { fax, postcode, city, country, name, address, zapiId } = this.model;

    this.card.partner = {
      fax,
      postcode,
      city,
      country,
      name,
      address,
      zapiId,
    };
    this.card.purpose = this.model.purpose;
    this.card.comment = this.model.comment;
    this.card.mref = this.model.mref;
    this.card.fax = this.model.fax;

    /* 
      assign email and preferred contact, its value is not in form 
      but needed in api otherwise possible email contacts get
      informed by letter
    */
    if (this.card.partner) {
      this.card.partner.email = this.model.email;
      this.card.partner.preferredContact = this.model.preferredContact;
    }

    if (this.hasContracts) {
      this.card.contracts = this.model.contracts;
    } else {
      this.card.purpose = this.model.purpose;
    }
  }

  openAddressSection() {
    this.isAddressOpen = true;
  }

  get hasContracts() {
    return this.card.contracts;
  }

  get hasIncompletePartner() {
    const { fax, postcode, city, country, name } = this.model;
    const completeAddress = city && postcode && country;
    if ((!fax && !completeAddress) || !name) {
      return true;
    }
    return false;
  }

  confirmPaymentPartner() {
    if (this.form.$invalid) {
      this.openAddressSection();
      return;
    }

    this.assignModelToCard();

    const { type, ticketId, id, paymentPartnerId, contracts } = this.card;
    const data = {
      type,
      id,
      paymentPartnerId,
      data: {
        ...this.card.partner,
      },
      contracts: _.filter(contracts, { active: true }),
      purpose: this.card.purpose,
      comment: this.card.comment,
      mref: this.card.mref,
    };

    this.ticketService
      .updatePaymentPartner(ticketId, data)
      .busy(this, 'isCardSaving')
      .then(() => {
        this.close({ $value: this.card });
      });
  }
}
